// src/utils/loadingOverlay.js

let loadingTimer;

export const showLoading = () => {
    clearTimeout(loadingTimer);
    loadingTimer = setTimeout(() => {
        const overlay = document.getElementById("loading-overlay");
        if (overlay) overlay.classList.remove("hidden");
    }, 200); // Show only if it takes more than 2s
};

export const hideLoading = () => {
    clearTimeout(loadingTimer);
    const overlay = document.getElementById("loading-overlay");
    if (overlay) overlay.classList.add("hidden");
};
